/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
import { useState } from "react"
import { EnvelopeIcon } from "@heroicons/react/24/outline"
import Highlighter from "react-highlight-words"
import cc from "classcat"
import LocalizedLink from "components/LocalizedLink"
import ImageTeamMember from "components/ImageTeamMember"
import useTranslations from "hooks/useTranslations"

const CardDescription = ({ text, highlight }) => (
  <Highlighter
    highlightClassName="font-bold underline bg-transparent "
    searchWords={highlight || [""]}
    autoEscape
    textToHighlight={text}
    className="text-zinc-800"
  />
)

const Link = ({ portraitFirst, link, children }) => {
  return (
    <LocalizedLink
      className={cc([
        "flex cursor-pointer items-start space-y-8 pt-6 first:pl-0 md:px-6 md:pt-0",
        portraitFirst ? "flex-col-reverse space-y-reverse" : "flex-col",
      ])}
      to={link}
    >
      {children}
    </LocalizedLink>
  )
}

const NoLink = ({ portraitFirst, children }) => {
  return (
    <div
      className={cc([
        "flex items-start space-y-8 pt-6 first:pl-0 md:px-6 md:pt-0",
        portraitFirst ? "flex-col-reverse space-y-reverse" : "flex-col",
      ])}
    >
      {children}
    </div>
  )
}

const PreventCard = ({
  name,
  highlight = [],
  title,
  image,
  position,
  email,
  readMore,
  link,
  portraitFirst,
  readAll,
  showReadMore,
}) => {
  const Wrapper = link ? Link : NoLink

  return (
    <Wrapper link={link} portraitFirst={portraitFirst}>
      <div
        className="relative mb-0 grow cursor-pointer whitespace-pre-line text-left font-body text-xl text-zinc-800"
        // onClick={() => setReadAll(!readAll)}
      >
        {Array.isArray(title) ? (
          <ul
            className={cc([
              " list-none space-y-1.5 overflow-y-hidden text-base",
              showReadMore && !readAll ? "md:max-h-52" : "md:max-h-full",
            ])}
          >
            {title.map((t) => (
              <li className="text-kkm-green">
                <CardDescription text={t} highlight={highlight} />
              </li>
            ))}
          </ul>
        ) : (
          <CardDescription text={title} highlight={highlight} />
        )}
        {readMore && (
          <span className="m-0 ml-2 max-w-xs cursor-pointer text-base text-kkm-green underline hover:text-kkm-darkgreen">
            {readMore}
          </span>
        )}
      </div>
      <div className="flex items-start space-x-4 lg:space-x-6">
        <ImageTeamMember
          className="w-16 lg:w-20"
          imgClassName="rounded-full"
          filename={image}
          alt={name}
        />
        <div className="space-y-1">
          <p className="m-0 whitespace-pre-line font-display text-lg text-zinc-800">
            {name}
          </p>
          {position && (
            <p className="m-0 whitespace-pre-line font-display text-sm text-kkm-darkgreen">
              {position}
            </p>
          )}
          {email && (
            <p className="m-0 font-display text-lg text-zinc-800">
              <a href={`mailto:${email}`} onClick={(e) => e.preventDefault}>
                <EnvelopeIcon className="w-5 text-kkm-darkgreen" />
              </a>
            </p>
          )}
        </div>
      </div>
    </Wrapper>
  )
}

export default function Protection({
  features,
  title,
  readMore,
  link,
  portraitFirst,
  showReadMore,
}) {
  const [readAll, setReadAll] = useState(false)
  const { buttonMore } = useTranslations()
  return (
    <div className="relative bg-white py-12 lg:py-24">
      <div className="mx-auto px-4 sm:max-w-3xl sm:px-6 lg:max-w-7xl lg:px-8">
        <p className="m-0 max-w-2xl py-4 text-left font-display text-4xl font-extrabold text-zinc-900 sm:text-5xl">
          {title}
        </p>
        <div
          className="relative md:mt-12"
          onClick={() => showReadMore && setReadAll(!readAll)}
        >
          <div className="grid space-y-10 divide-y divide-kkm-green md:grid-cols-3 md:flex-row md:space-y-0 md:divide-x md:divide-y-0">
            {features.map((item) => (
              <PreventCard
                {...item}
                link={link}
                key={item.id}
                readMore={readMore}
                portraitFirst={portraitFirst}
                readAll={readAll}
                setReadAll={setReadAll}
                showReadMore={showReadMore}
              />
            ))}
          </div>
          {showReadMore && !readAll && (
            <div className="absolute bottom-0 left-0 right-0 hidden h-10 cursor-pointer bg-gradient-to-t from-white text-center md:block">
              <span className="relative -bottom-10 text-xs font-bold text-kkm-darkgreen">
                {buttonMore}
              </span>
            </div>
          )}
        </div>
      </div>
    </div>
  )
}
